/**
 * correspondentManageMentModule 通讯员管理
 * author Qian.qianchen 2019-09-27
 * 
 */
'use strict';
angular.module('correspondentManageMentModule', ['correspondentRouterModule', 'correspondentServiceModule']).
controller('correspondentManageMentController', ['$scope', '$q', '$stateParams', '$state', 'trsHttpService', 'modalDialog', 'trsspliceString', 'correspondentService',
    function($scope, $q, $stateParams, $state, trsHttpService, modalDialog, trsspliceString, correspondentService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                sourceOptions: [{ name: '全部来源', value: -1 }, { name: '新疆维吾尔自治区媒体云平台新增', value: 0 }, { name: 'MCN', value: 1 }],
                selectedSource: { name: '全部来源', value: -1 },
                page: {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    PAGECOUNT: 0,
                    ITEMCOUNT: 0
                }
            }
            $scope.data = {
                keywords: "",
                selectedArray: [],
                correspondentArray: []
            }
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_commuser",
                methodname: "querryCommUsers",
                userType: $scope.status.selectedSource.value,
                Keyword: $scope.data.keywords,
                PageSize: $scope.status.page.PAGESIZE,
                PageIndex: $scope.status.page.CURRPAGE
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then((data) => {
                $scope.data.correspondentArray = data.DATA;
                $scope.status.page = data.PAGER;
                $scope.data.copyCurrPage = $scope.status.page.CURRPAGE;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [hasMcnCorrespondent description] 选中的数组中是否含有mcn通讯员
         * @return {Boolean} [description]
         */
        function hasMcnCorrespondent() {
            return $scope.data.selectedArray.some((_item) => {
                return _item.USERTYPE == 1;
            });
        }
        /**
         * [requestData description] 数据请求
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.requestData = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        }
        /**
         * [gotoPage description] 分页跳转
         * @return {[type]} [description]
         */
        $scope.gotoPage = function() {
            $scope.status.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        }
        /**
         * [isChecked description] 判断是否选中
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some((_item) => {
                return _item.COMMUSERID == item.COMMUSERID;
            });
        }
        /**
         * [selectItem description] 选中/取消选中item
         * @param  {[type]} item [description] 
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => {
                    return _item.COMMUSERID != item.COMMUSERID;
                });
            } else {
                $scope.data.selectedArray.push(item);
            }
        }
        /**
         * [selectAll description] 全选/取消全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.isSelectAll()) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [...$scope.data.correspondentArray];
            }
        }

        /**
         * [isSelectAll description] 全选
         * @return {Boolean} [description]
         */
        $scope.isSelectAll = function() {
            if ($scope.data.correspondentArray.length > 0 && $scope.data.selectedArray.length == $scope.data.correspondentArray.length) {
                return true;
            }
            return false;
        }
        /**
         * [editCorrespondent description] 新建/编辑通讯员
         * @param  {[type]} item [description] 通讯员
         * @return {[type]}      [description]
         */
        $scope.editCorrespondent = function(item) {
            $state.go('manageconfig.groupmanage.correspondent.editcorrespondent', { correspondentId: angular.isDefined(item) ? item.COMMUSERID : 0 });
        }

        /**
         * [deleteCorrespondent description] 删除通讯员
         * @param  {[type]} item [description] 通讯员
         * @return {[type]}      [description]
         */
        $scope.deleteCorrespondent = function(item) {
            if (angular.isUndefined(item) && $scope.data.selectedArray.length == 0) {
                modalDialog.alertType("", "请选择要删除的通讯员！", "error", false);
                return;
            }
            if (angular.isUndefined(item) && $scope.data.selectedArray.length > 0 && hasMcnCorrespondent()) {
                modalDialog.alertType("", "选择的通讯员中含有MCN通讯员无法删除！", "error", false);
                return;
            }
            let params = {
                serviceid: "mlf_commuser",
                methodname: "deleteCommUsers",
                ids: angular.isDefined(item) ? item.COMMUSERID : trsspliceString.spliceString($scope.data.selectedArray, 'COMMUSERID', ',')
            }
            modalDialog.confirmModal('', '确定删除通讯员？', () => {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then((data) => {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType('删除成功', '', 'success', false, () => {
                            $scope.data.selectedArray = [];
                            requestData();
                        });
                    }
                }, (error) => {
                    $scope.data.selectedArray = [];
                    requestData();
                });
            });
        }
        /**
         * [correspondentDetail description] 通讯员详情
         * @param  {[type]} item [description] 通讯员
         * @return {[type]}      [description]
         */
        $scope.correspondentDetail = function(item) {
            correspondentService.correspondentDetail(item.COMMUSERID).then(() => {

            });
        }
    }
]);